module.exports = __webpack_public_path__ + "static/media/n.b8fa2f68.m4a";